<template>
  <div :class="[ps.fullscreen, 'restricted-container']">
    <h1>wuh oh you don't have access to that page sorry xd !!</h1>
  </div>
</template>

<script>
import pageStyles from '@/styles/page.module.css';

export default {
  name: 'RestrictedView',
  data () {
    return {
      ps: pageStyles
    }
  }
}
</script>

<style scoped>
.restricted-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>